import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { planPublicPathSchema } from '@plans/shared';
import { ApiError, plansApi } from '../api/client.js';

function pathHint(value: string): { ok: boolean; message: string } {
  const trimmed = value.trim();
  if (!trimmed) {
    return { ok: true, message: 'اترك الحقل فارغًا لاستخدام المعرف التلقائي.' };
  }
  const parsed = planPublicPathSchema.safeParse(trimmed);
  if (!parsed.success) {
    return { ok: false, message: parsed.error.issues[0]?.message ?? 'المسار العام غير صالح.' };
  }
  return { ok: true, message: `سيكون الرابط العام /${parsed.data}/` };
}

export function CreatePlanPage() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [publicPath, setPublicPath] = useState('');
  const [published, setPublished] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);
  const hint = pathHint(publicPath);

  return (
    <form
      className="stack form-narrow"
      onSubmit={(event) => {
        event.preventDefault();
        if (!hint.ok) {
          setError(hint.message);
          return;
        }
        setPending(true);
        setError(null);
        void plansApi
          .create(title, published, publicPath.trim() === '' ? null : publicPath.trim())
          .then(({ plan }) => navigate(`/plans/${plan.id}`))
          .catch((err: unknown) => {
            setError(err instanceof ApiError ? err.message : 'تعذر إنشاء الخطة.');
          })
          .finally(() => setPending(false));
      }}
    >
      <div>
        <h1>إنشاء خطة</h1>
        <p className="muted">يُنشأ معرف تلقائي ويُستخدم كمسار عام ما لم تختر مسارًا مخصصًا.</p>
      </div>
      <label>
        العنوان
        <input
          type="text"
          required
          maxLength={200}
          value={title}
          onChange={(event) => setTitle(event.target.value)}
        />
      </label>
      <label>
        مسار عام مخصص
        <input
          type="text"
          dir="ltr"
          maxLength={64}
          autoComplete="off"
          spellCheck={false}
          placeholder="acme-2026"
          value={publicPath}
          onChange={(event) => setPublicPath(event.target.value)}
        />
      </label>
      <p className={`field-hint ${hint.ok ? 'muted' : 'error'}`}>{hint.message}</p>
      <label className="check-row">
        <input
          type="checkbox"
          checked={published}
          onChange={(event) => setPublished(event.target.checked)}
        />
        نشر الخطة فورًا
      </label>
      {error && <p className="error">{error}</p>}
      <div className="section-actions">
        <button className="btn" type="submit" disabled={pending || title.trim().length === 0 || !hint.ok}>
          {pending ? 'جارٍ الإنشاء…' : 'إنشاء الخطة'}
        </button>
      </div>
    </form>
  );
}
